import type { SlideProps } from "@/engine/app/offsite-config";

/**
 * Titel-/Hub-Folie des NW-Offsites — Struktur wie Netzkunden: Kapitelkarten
 * mit Sprungzielen. Die Folien-Nummern stimmen mit deck.ts überein:
 * 17 = Aktivierung (Workshop-Einstieg), 21 = SVO OS, 23 = Reveal, 26 = Themen.
 */
const WORKSHOP_BRIDGE_SLIDE = 17;

export function Slide01Titel({ onJump }: SlideProps) {
  const goTo = (slideNumber: number) => {
    if (onJump) onJump(slideNumber);
  };

  return (
    <div className="deck-root" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-80px",
          right: "-120px",
          background: "var(--svo-blau)",
          opacity: 0.35,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-80px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.18,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1" style={{ color: "var(--svo-blau)" }}>
          Offsite Netzwirtschaft · Oktober 2026
        </div>
        <h1 className="deck-title rise rise-2" style={{ color: "#fff" }}>
          Digitalisierung <br />
          <span className="accent">und KI in der Netzwirtschaft</span>
        </h1>
        <p
          className="deck-sub rise rise-3"
          style={{ color: "rgba(255,255,255,0.78)" }}
        >
          Weniger Abtippen, weniger Abgleichen von Hand — und ihr probiert
          selbst aus, wie das geht: heute verstehen, morgen bauen.
        </p>
      </header>

      <div className="deck-flow">
        <div className="chapter rise rise-4">
          <div className="chapter-num">01</div>
          <div className="chapter-title">
            KI <span className="alt">verstehen</span>
          </div>
          <div className="chapter-desc">
            Was heute schon automatisch läuft — und was KI wirklich ist.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Grundlagen</div>
            <div className="chapter-arrow">→</div>
          </div>
        </div>

        <button
          type="button"
          className="chapter-bridge chapter-bridge-clickable rise rise-5"
          onClick={() => goTo(WORKSHOP_BRIDGE_SLIDE)}
          title={`Springe zu Folie ${WORKSHOP_BRIDGE_SLIDE} — Workshop-Einstieg`}
        >
          <div className="chapter-bridge-pill">
            <span className="chapter-bridge-icon">⚡</span>
            <div className="chapter-bridge-text">
              <span className="chapter-bridge-eyebrow">Teamarbeit</span>
              <span className="chapter-bridge-title">
                Jedes Team beschreibt der KI seinen Anwendungsfall — sie baut ihn.
              </span>
              <span className="chapter-bridge-action">→ Folie {WORKSHOP_BRIDGE_SLIDE}</span>
            </div>
          </div>
        </button>

        <button
          type="button"
          className="chapter chapter-clickable rise rise-5"
          onClick={() => goTo(22)}
          title="Springe zu Folie 22"
        >
          <div className="chapter-num">02</div>
          <div className="chapter-title">
            SVO OS <span className="alt">erleben</span>
          </div>
          <div className="chapter-desc">
            Live-Demo: was mit KI gebaute Software heute schon kann.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Live-Demo · Folie 22</div>
            <div className="chapter-arrow">→</div>
          </div>
        </button>

        <button
          type="button"
          className="chapter-bridge chapter-bridge-clickable rise rise-6"
          onClick={() => goTo(24)}
          title="Springe zu Folie 24 — Reveal"
        >
          <div className="chapter-bridge-pill">
            <span className="chapter-bridge-icon">✨</span>
            <div className="chapter-bridge-text">
              <span className="chapter-bridge-eyebrow">Reveal · Tag 2</span>
              <span className="chapter-bridge-title">
                Was die KI aus euren Steckbriefen gebaut hat.
              </span>
              <span className="chapter-bridge-action">→ Folie 24</span>
            </div>
          </div>
        </button>

        <button
          type="button"
          className="chapter chapter-clickable rise rise-6"
          onClick={() => goTo(27)}
          title="Springe zu Folie 27"
        >
          <div className="chapter-num">03</div>
          <div className="chapter-title">
            Eure <span className="alt">Themen</span>
          </div>
          <div className="chapter-desc">
            Erkenntnisse, Sorgen, Ausblick — offene Runde.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Austausch · Folie 27</div>
            <div className="chapter-arrow">→</div>
          </div>
        </button>
      </div>

      <footer className="deck-foot" style={{ color: "rgba(255,255,255,0.55)" }}>
        <span>Viktor Lüders · IT Requirements Manager</span>
        <span>SVO · Celle · Uelzen</span>
      </footer>
    </div>
  );
}
